import React, { Fragment } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { NumericEditor } from "../../dataGrid/cellEditors";

const styles = (theme) => ({
  gridItemHead: {
    fontWeight: 600,
  },
  gridItem: {
    fontSize: theme.textFontSize,
    color: theme.gridTextColor,
    "&>div": {
      marginTop: 0,
    },
    "&$gridItemHead": {
      paddingRight: 0,
    },
    "&$dropDownStyle": {
      paddingTop: 7,
    },
  },
  dropDownStyle: {},
});

class EquipmentTypes extends React.Component {
  constructor(props) {
    super(props);
    this.inputRefs = {};
  }

  componentDidMount() {
    const index = Object.keys(this.inputRefs)[0];
    this.inputRefs[index].focusOnInput();
  }

  onChange = () => {
    this.props.updateEquipmentTypeCount(this.inputRefs);
  };

  render() {
    const { data, classes } = this.props;
    return (
      <Fragment>
        {data.map((equipment) => (
          <Fragment key={equipment.equipmentName}>
            <Grid
              item
              xs={6}
              sm={3}
              md={2}
              classes={{
                item: `${classes.gridItem} ${classes.gridItemHead}`,
              }}
            >
              {`${equipment.equipmentName} ${equipment.tempType ? `(${equipment.tempType})`:""}`} :
            </Grid>
            <Grid
              item
              xs={6}
              sm={3}
              md={2}
              classes={{ item: classes.gridItem }}
            >
              <NumericEditor
                value={null}
                onChange={this.onChange}
                equipmentId={equipment.equipmentId}
                ref={(ref) => (this.inputRefs[equipment.equipmentName] = ref)}
              />
            </Grid>
          </Fragment>
        ))}
      </Fragment>
    );
  }
}

export default withStyles(styles)(EquipmentTypes);
